import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

const useStyles = makeStyles(theme => {
	return {
		scroll: {
			marginRight: -theme.spacing(2),
			paddingRight: theme.spacing(2)
		}
	};
});

type ScrollBarProps = {
	children: React.ReactNode;
	className: string;
};

const ScrollBars: React.FC<ScrollBarProps> = props => {
	const classes = useStyles();
	return (
		<SimpleBar autoHide={true} className={clsx(classes.scroll, props.className)}>
			{props.children}
		</SimpleBar>
	);
};

export default ScrollBars;
